import { cn } from 'cn';
import { memo } from 'react';

type P = {
  readonly title: string;
} & ComponentStyling;

export const PageTitle = memo(({ children, className, style, ...props }: P) => (
  <h1 {...props} className={cn('text-3xl', className)} style={style}>
    {children}
  </h1>
));
